import {
  types,
  IGroupDetailed,
  ICreateGroupAction,
  ICreateGroupSuccessAction,
  IFailureAction,
  IGetGroupByIdAction,
  IGetGroupByIdSuccessAction,
  IUpdateGroupAction,
  IUpdateGroupSuccessAction,
  IDeleteGroupAction,
  IDeleteGroupSuccessAction,
  IClearGroupDataAction,
} from '../types/group'

export const createGroup = (groupData: IGroupDetailed): ICreateGroupAction => ({
  type: types.CREATE_GROUP__STARTED,
  groupData,
})

export const createGroupSuccess = (
  groupData: IGroupDetailed,
  message: string
): ICreateGroupSuccessAction => ({
  type: types.CREATE_GROUP__SUCCESS,
  groupData,
  message,
})

export const createGroupFailure = (message: string): IFailureAction => ({
  type: types.CREATE_GROUP__FAILURE,
  message,
})

export const getGroupById = (groupId: string): IGetGroupByIdAction => ({
  type: types.GET_GROUP_BY_ID__STARTED,
  groupId,
})

export const getGroupByIdSuccess = (
  groupData: IGroupDetailed
): IGetGroupByIdSuccessAction => ({
  type: types.GET_GROUP_BY_ID__SUCCESS,
  groupData,
})

export const getGroupByIdFailure = (message: string): IFailureAction => ({
  type: types.GET_GROUP_BY_ID__FAILURE,
  message,
})

export const updateGroup = (
  groupData: IGroupDetailed,
  initialCapabilitiesIds?: string[]
): IUpdateGroupAction => ({
  type: types.UPDATE_GROUP__STARTED,
  groupData,
  initialCapabilitiesIds,
})

export const updateGroupSuccess = (
  groupData: IGroupDetailed,
  message: string
): IUpdateGroupSuccessAction => ({
  type: types.UPDATE_GROUP__SUCCESS,
  groupData,
  message,
})

export const updateGroupFailure = (message: string): IFailureAction => ({
  type: types.UPDATE_GROUP__FAILURE,
  message,
})

export const deleteGroup = (groupId): IDeleteGroupAction => ({
  type: types.DELETE_GROUP__STARTED,
  groupId,
})

export const deleteGroupSuccess = (
  message: string
): IDeleteGroupSuccessAction => ({
  type: types.DELETE_GROUP__SUCCESS,
  message,
})

export const deleteGroupFailure = (message: string): IFailureAction => ({
  type: types.DELETE_GROUP__FAILURE,
  message,
})

export const clearGroupData = (): IClearGroupDataAction => ({
  type: types.CLEAR_GROUP_DATA,
})
